"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[376],{

/***/ 56123:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IR": () => (/* binding */ linkToAdminControlPanel),
/* harmony export */   "sc": () => (/* binding */ linkToAdminBillingManagement),
/* harmony export */   "un": () => (/* binding */ linkToAdminDataExport),
/* harmony export */   "ys": () => (/* binding */ linkToAdminInvestigationItemGenerator)
/* harmony export */ });
/* unused harmony exports linkToAdmin, linkToAdminFacilityManagement, linkToAdminInvestigations */
function linkToAdmin() {
  return "/admin";
}
function linkToAdminDataExport() {
  return `${linkToAdmin()}/data-export`;
}
function linkToAdminControlPanel() {
  return `${linkToAdmin()}/control-panel`;
}
function linkToAdminBillingManagement() {
  return `${linkToAdmin()}/billing-management`;
}
function linkToAdminFacilityManagement() {
  return `${linkToAdmin()}/facility-management`;
}
function linkToAdminInvestigations() {
  return `${linkToAdmin()}/investigations`;
}
function linkToAdminInvestigationItemGenerator() {
  return `${linkToAdminInvestigations()}/item-generator`;
}


/***/ }),

/***/ 43750:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65791);

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((configOverride) => {
  const config = configOverride || window.__CONFIG_SERVICE_CONFIG__ || {};
  return {
    path: `${(0,ramda__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("", ["authServiceUrl"], config)}/`,
    clinicalSubscriptionServicePath: `${(0,ramda__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(
      "",
      ["clinicalSubscriptionServiceUrl"],
      config
    )}/`,
    federationPath: `${(0,ramda__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("", ["federationPath"], config)}`
  };
});


/***/ }),

/***/ 30668:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": () => (/* binding */ ApolloProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63066);
/* harmony import */ var _elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23198);
/* harmony import */ var _auth_SessionTokenProvider_SessionTokenProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1767);
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77430);
/* harmony import */ var _RetryApolloContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92560);






const ApolloProvider = ({
  children
}) => {
  const config = (0,_elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_1__/* .useConfig */ .ZR)();
  const { sessionToken: token } = (0,_auth_SessionTokenProvider_SessionTokenProvider__WEBPACK_IMPORTED_MODULE_2__/* .useSessionTokenContext */ .ic)();
  const apolloCache = (0,_client__WEBPACK_IMPORTED_MODULE_3__/* .newCache */ .Hd)();
  const client = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => (0,_client__WEBPACK_IMPORTED_MODULE_3__/* .getApolloClient */ .WQ)(config, apolloCache, token),
    [config, apolloCache, token]
  );
  const retryClient = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(
    () => (0,_client__WEBPACK_IMPORTED_MODULE_3__/* .getRetryApolloClient */ .FW)(config, apolloCache, token),
    [config, apolloCache, token]
  );
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .ApolloProvider */ .e, {
    client
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_RetryApolloContext__WEBPACK_IMPORTED_MODULE_4__/* .RetryApolloProvider */ .W, {
    client: retryClient
  }, children));
};


/***/ }),

/***/ 92560:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": () => (/* binding */ useRetryApolloClient),
/* harmony export */   "W": () => (/* binding */ RetryApolloProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);

const ApolloRetryContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(
  null
);
function RetryApolloProvider({
  client,
  children
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ApolloRetryContext.Provider, {
    value: client
  }, children);
}
function useRetryApolloClient() {
  const client = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ApolloRetryContext);
  if (!client) {
    throw new Error(
      'Could not find "client" in the context or passed in as a prop. Wrap the root component in a <RetryApolloProvider>'
    );
  }
  return client;
}


/***/ }),

/***/ 77430:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ux": () => (/* binding */ customDataIdFromObject),
  "WQ": () => (/* binding */ getApolloClient),
  "FW": () => (/* binding */ getRetryApolloClient),
  "Hd": () => (/* binding */ newCache)
});

// UNUSED EXPORTS: shouldRetry

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/link/http/HttpLink.js + 16 modules
var HttpLink = __webpack_require__(11974);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/link/core/ApolloLink.js + 3 modules
var ApolloLink = __webpack_require__(19956);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/core/ApolloClient.js + 4 modules
var ApolloClient = __webpack_require__(70970);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 8 modules
var inMemoryCache = __webpack_require__(42401);
// EXTERNAL MODULE: ./src/client/api/endpoints.js
var endpoints = __webpack_require__(43750);
// EXTERNAL MODULE: ./src/client/common/i18n/usePersistUserLanguage.js
var usePersistUserLanguage = __webpack_require__(22518);
// EXTERNAL MODULE: ./src/client/utils/globals.js
var globals = __webpack_require__(42359);
;// CONCATENATED MODULE: ./src/client/apollo/typePolicies.ts
function mergeOffsetLimitResult(listKey = "items") {
  return (existing = {}, incoming = null) => {
    if (!incoming) {
      return existing;
    }
    const merged = existing[listKey] ? existing[listKey].slice(0) : [];
    const start = incoming.offset;
    const end = start + incoming[listKey].length;
    for (let i = start; i < end; ++i) {
      merged[i] = incoming[listKey][i - start];
    }
    return {
      ...incoming,
      [listKey]: merged
    };
  };
}
function offsetLimitPaginatedResult(keyArgs) {
  return {
    keyArgs,
    merge: mergeOffsetLimitResult()
  };
}
const apolloCacheTypePolicies = {
  Query: {
    fields: {
      patientTriageStatuses: {
        merge: false
      },
      investigationActivitiesPaginatedOffset: offsetLimitPaginatedResult([
        "input"
      ]),
      facilityQueues: {
        merge: false
      },
      getDepartments: {
        keyArgs: (_, { variables: { clinicId } }) => JSON.stringify({ clinicId }),
        merge: mergeOffsetLimitResult("list"),
        read: (existing, { args: { input: { pagination } } }) => {
          var _a;
          if (!existing || !existing.list) {
            return existing;
          }
          const serverHasMoreItemsThanCurrentPaginationLimit = pagination.total > pagination.limit && ((_a = existing.list) == null ? void 0 : _a.length) < pagination.limit;
          if (serverHasMoreItemsThanCurrentPaginationLimit) {
            return void 0;
          }
          return {
            ...existing,
            list: existing.list.slice(
              pagination.offset,
              pagination.offset + pagination.limit
            )
          };
        }
      }
    }
  },
  VisitLocationSnapshot: {
    keyFields: (o) => `${o._id}-${o.created}`
  },
  VisitDepartmentSnapshot: {
    keyFields: (o) => `${o._id}-${o.careEventCreatedAt}`
  },
  VisitCareEvent: {
    keyFields: ["_id", "type"]
  },
  VisitInvestigationActivity: {
    keyFields: ["_id", "outcome"]
  },
  VisitPatientVital: {
    keyFields: (o) => `${o.__typename}:${o.visitId}:${o.id}`
  },
  User: {
    fields: {
      person: {
        merge: false
      }
    }
  },
  Patient: {
    fields: {
      consultations: {
        merge(existingReadOnly, incoming, { readField }) {
          const existing = existingReadOnly ? existingReadOnly.slice(0) : [];
          const incomingIdSet = new Set(
            incoming.map((consultation) => readField("id", consultation))
          );
          const existingFiltered = existing.filter(
            (task) => !incomingIdSet.has(readField("id", task))
          );
          return [...existingFiltered, ...incoming];
        }
      }
    }
  },
  PatientQueue: {
    fields: {
      patients: {
        merge: false
      }
    }
  }
};
/* harmony default export */ const typePolicies = (apolloCacheTypePolicies);

// EXTERNAL MODULE: ./node_modules/.pnpm/zen-observable-ts@1.2.5/node_modules/zen-observable-ts/module.js
var zen_observable_ts_module = __webpack_require__(11600);
;// CONCATENATED MODULE: ./src/client/apollo/ElephantRetryLink.ts

function RetryableOperation(operation, nextLink, delayFor, retryIf) {
  const values = [];
  const observers = [];
  let currentSubscription = null;
  let complete = false;
  let error = null;
  let timerId = null;
  let retryCount = 0;
  function scheduleRetry(delay) {
    timerId = setTimeout(() => {
      timerId = null;
      newTry();
    }, delay);
  }
  function onNext(value) {
    const shouldRetry = retryIf(retryCount + 1, operation, value, void 0);
    if (shouldRetry) {
      retryCount += 1;
      scheduleRetry(delayFor(retryCount, operation, value, void 0));
      return;
    }
    values.push(value);
    observers.forEach((observer) => {
      if (observer) {
        observer.next(value);
      }
    });
  }
  async function onError(err) {
    const shouldRetry = await retryIf(
      retryCount + 1,
      operation,
      void 0,
      err
    );
    if (shouldRetry) {
      retryCount += 1;
      scheduleRetry(delayFor(retryCount, operation, void 0, err));
      return;
    }
    error = err;
    observers.forEach((observer) => {
      if (observer) {
        observer.error(err);
      }
    });
  }
  function onComplete() {
    if (!timerId) {
      complete = true;
      observers.forEach((observer) => {
        if (observer) {
          observer.complete();
        }
      });
    }
  }
  function newTry() {
    currentSubscription = nextLink(operation).subscribe({
      next: onNext,
      error: onError,
      complete: onComplete
    });
  }
  function start() {
    if (currentSubscription)
      return;
    newTry();
  }
  function subscribe(observer) {
    observers.push(observer);
    values.forEach(observer.next);
    if (complete) {
      observer.complete();
    } else if (error) {
      observer.error(error);
    }
  }
  function cancel() {
    if (currentSubscription) {
      currentSubscription.unsubscribe();
    }
    clearTimeout(timerId);
    timerId = null;
    currentSubscription = null;
  }
  function unsubscribe(observer) {
    const index = observers.indexOf(observer);
    if (index >= 0) {
      observers[index] = null;
    }
    if (observers.every((o) => o === null)) {
      cancel();
    }
  }
  return {
    start,
    subscribe,
    unsubscribe
  };
}
class ElephantRetryLink extends ApolloLink/* ApolloLink */.i {
  constructor(args) {
    super();
    this.delayFor = args.calculateDelay;
    this.retryIf = args.shouldRetry;
  }
  request(operation, nextLink) {
    const retryable = RetryableOperation(
      operation,
      nextLink,
      this.delayFor,
      this.retryIf
    );
    retryable.start();
    return new zen_observable_ts_module/* Observable */.y((observer) => {
      retryable.subscribe(observer);
      return () => {
        retryable.unsubscribe(observer);
      };
    });
  }
}

// EXTERNAL MODULE: ./src/client/timestamps/index.ts
var timestamps = __webpack_require__(70807);
// EXTERNAL MODULE: ./src/client/clinical-engine/data-sync/IDataController.ts
var IDataController = __webpack_require__(49173);
;// CONCATENATED MODULE: ./src/client/apollo/client.ts









const getHttpLink = (config) => new HttpLink/* HttpLink */.u({ uri: `${(0,endpoints/* default */.Z)(config).federationPath}` });
const getHeadersMiddleware = (token) => new ApolloLink/* ApolloLink */.i((operation, forward) => {
  var _a;
  const customHeaders = (_a = operation.getContext().headers) != null ? _a : {};
  const headers = {
    "X-Elephant-Locale": (0,usePersistUserLanguage/* getUserLanguage */.o)(),
    ...customHeaders
  };
  if (token && !headers[IDataController/* requestSignatureHeader */.x]) {
    headers.authorization = token;
  }
  operation.setContext({
    headers
  });
  return forward(operation);
});
const dateMiddleware = new ApolloLink/* ApolloLink */.i((operation, forward) => {
  return forward(operation).map((response) => {
    const context = operation.getContext();
    const dateHeader = context.response.headers.get("Date");
    timestamps/* default.getInstance */.Z.getInstance().setTime(new Date(dateHeader));
    return response;
  });
});
function customDataIdFromObject(object) {
  var _a, _b;
  const { __typename, id, _id, uuid } = object;
  if (__typename === "CatalogueCoding") {
    const coding = object;
    return `${__typename}:l-${(_a = coding.loinc) == null ? void 0 : _a.code}:e-${(_b = coding.elephant) == null ? void 0 : _b.code}`;
  }
  if (typeof __typename === "string") {
    if (typeof id === "string")
      return `${__typename}:${id}`;
    if (typeof _id === "string")
      return `${__typename}:${_id}`;
    if (typeof uuid === "string")
      return `${__typename}:${uuid}`;
  }
  return null;
}
function calculateDelay(count) {
  return (count > 5 ? 5 : count) * 1e3 * Math.random();
}
function shouldRetry(count, operation, value, proxyError) {
  var _a;
  const isQuery = operation.query.definitions.reduce((acc, def) => {
    if (def.kind === "OperationDefinition") {
      return acc && (!def.operation || def.operation === "query");
    }
    return acc;
  }, true);
  const maybeResponse = value;
  const hostNetError = (_a = maybeResponse == null ? void 0 : maybeResponse.errors) == null ? void 0 : _a.find(
    (err) => err.message.includes("ECONNREFUSED")
  );
  const retry = isQuery && (!!hostNetError || !!proxyError);
  if (retry) {
    const onRetryHandler = operation.getContext().onRetry;
    if (onRetryHandler) {
      onRetryHandler();
    }
  }
  return retry;
}
const retryLink = new ElephantRetryLink({ calculateDelay, shouldRetry });
const newCache = () => new inMemoryCache/* InMemoryCache */.h({
  dataIdFromObject: customDataIdFromObject,
  typePolicies: typePolicies,
  possibleTypes: {
    StockTakeLot: ["StockTakeLotUpdate", "StockTakeLotAddition"]
  }
});
const baseApolloLink = (config, additionalLinks = [], token) => {
  return ApolloLink/* ApolloLink.from */.i.from([
    getHeadersMiddleware(token),
    dateMiddleware,
    ...additionalLinks,
    getHttpLink(config)
  ]);
};
const baseApolloConfig = (config, cache, links = [], token) => ({
  cache: cache || newCache(),
  link: baseApolloLink(config, links, token),
  name: `primary-care-web-${config == null ? void 0 : config.territory}`,
  version: globals/* APP_VERSION */.Ji,
  connectToDevTools: /(127\.0\.0\.1|localhost|acceptance)/i.test(window.origin)
});
const getApolloClient = (config, cache, token) => new ApolloClient/* ApolloClient */.f(baseApolloConfig(config, cache, [], token));
const getRetryApolloClient = (config, cache, token) => {
  return new ApolloClient/* ApolloClient */.f(baseApolloConfig(config, cache, [retryLink], token));
};


/***/ }),

/***/ 1767:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hW": () => (/* binding */ SessionTokenProvider),
/* harmony export */   "ic": () => (/* binding */ useSessionTokenContext)
/* harmony export */ });
/* unused harmony export SessionTokenContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var usehooks_ts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59288);


const SESSION_TOKEN_KEY = "token";
const SessionTokenContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
function useSessionTokenContext() {
  const context = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SessionTokenContext);
  if (!context) {
    throw new Error(
      "useSessionTokenContext must be used within a SessionTokenContext"
    );
  }
  return context;
}
const SessionTokenProvider = ({ sessionStorageKey = SESSION_TOKEN_KEY, children }) => {
  const [token, setToken] = (0,usehooks_ts__WEBPACK_IMPORTED_MODULE_1__/* .useSessionStorage */ .Xs)(sessionStorageKey, null);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(SessionTokenContext.Provider, {
    value: {
      sessionToken: token,
      setSessionToken: setToken,
      clearSessionToken: () => setToken(null)
    }
  }, children);
};


/***/ }),

/***/ 48462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D4": () => (/* binding */ SigningTokenProvider),
  "M_": () => (/* binding */ useSigningTokenContext)
});

// UNUSED EXPORTS: SigningTokenContext

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/date-fns@2.16.1/node_modules/date-fns/esm/addHours/index.js
var addHours = __webpack_require__(56312);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/usehooks-ts@2.9.1_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(59288);
// EXTERNAL MODULE: ./src/client/auth/SessionTokenProvider/SessionTokenProvider.tsx
var SessionTokenProvider = __webpack_require__(1767);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useLazyQuery.js
var useLazyQuery = __webpack_require__(90322);
;// CONCATENATED MODULE: ./src/client/auth/SigningTokenProvider/__generated__/SigningTokenProvider.gql.ts


const defaultOptions = {};
const FetchSigningTokenDocument = lib/* gql */.Ps`
    query FetchSigningToken {
  generateSigningToken {
    token
  }
}
    `;
function useFetchSigningTokenQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(FetchSigningTokenDocument, options);
}
function useFetchSigningTokenLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useLazyQuery/* useLazyQuery */.t(FetchSigningTokenDocument, options);
}

;// CONCATENATED MODULE: ./src/client/auth/SigningTokenProvider/SigningTokenProvider.tsx






const SIGNING_TOKEN_KEY = "signingToken";
const SIGNING_TOKEN_EXPIRY_KEY = "signingTokenExpiry";
lib/* gql */.Ps`
  query FetchSigningToken {
    generateSigningToken {
      token
    }
  }
`;
const SigningTokenContext = react.createContext(null);
function useSigningTokenContext() {
  const context = react.useContext(SigningTokenContext);
  if (!context) {
    throw new Error(
      "useSigningTokenContext must be used within a SigningTokenContext"
    );
  }
  return context;
}
const SigningTokenProvider = ({
  sessionStorageTokenKey = SIGNING_TOKEN_KEY,
  sessionStorageExpiryKey = SIGNING_TOKEN_EXPIRY_KEY,
  children
}) => {
  const { sessionToken } = (0,SessionTokenProvider/* useSessionTokenContext */.ic)();
  const [signingToken, setSigningToken] = (0,esm/* useSessionStorage */.Xs)(
    sessionStorageTokenKey,
    null
  );
  const [expiry, setExpiry] = (0,esm/* useSessionStorage */.Xs)(sessionStorageExpiryKey, null);
  const refetchOnExpiryTimemoutRef = (0,react.useRef)(null);
  const [fetchSigningToken] = useFetchSigningTokenLazyQuery({
    onCompleted: (data) => {
      if (data.generateSigningToken.token) {
        setSigningToken(data.generateSigningToken.token);
        setExpiry((0,addHours/* default */.Z)(new Date(), 23).toISOString());
      }
    }
  });
  (0,react.useEffect)(() => {
    if (!sessionToken) {
      clearTimeout(refetchOnExpiryTimemoutRef.current);
      return;
    }
    if (refetchOnExpiryTimemoutRef.current) {
      clearTimeout(refetchOnExpiryTimemoutRef.current);
    }
    const now = Date.now();
    const timeToExpiry = new Date(expiry != null ? expiry : now).getTime() - now;
    refetchOnExpiryTimemoutRef.current = setTimeout(
      fetchSigningToken,
      timeToExpiry
    );
  }, [expiry]);
  return /* @__PURE__ */ react.createElement(SigningTokenContext.Provider, {
    value: {
      signingToken,
      setSigningToken,
      clearSigningToken: () => {
        setSigningToken(null);
        setExpiry(null);
        clearTimeout(refetchOnExpiryTimemoutRef.current);
      }
    }
  }, children);
};


/***/ }),

/***/ 54481:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": () => (/* binding */ BlockingUserProvider)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36547);
/* harmony import */ var _SessionTokenProvider_SessionTokenProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1767);



const BlockingUserProvider = ({
  children
}) => {
  const { sessionToken: token } = (0,_SessionTokenProvider_SessionTokenProvider__WEBPACK_IMPORTED_MODULE_2__/* .useSessionTokenContext */ .ic)();
  if (!token)
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, children);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_elephant_healthcare_user_context_provider__WEBPACK_IMPORTED_MODULE_1__/* .UserContextProvider */ .fS, {
    token
  }, children);
};


/***/ }),

/***/ 52437:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": () => (/* binding */ Auth0Callback)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/@auth0+auth0-react@1.12.0_ef5jwxihqo6n7gxfmzogljlgcm/node_modules/@auth0/auth0-react/dist/auth0-react.esm.js
var auth0_react_esm = __webpack_require__(14432);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-router@6.15.0_react@18.1.0/node_modules/react-router/dist/index.js
var dist = __webpack_require__(76653);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(948);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Box/Box.js
var Box = __webpack_require__(95061);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/ErrorOutline.js
var ErrorOutline = __webpack_require__(11829);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var dist_module = __webpack_require__(2550);
// EXTERNAL MODULE: ./src/client/auth/auth0/links.js
var links = __webpack_require__(81041);
;// CONCATENATED MODULE: ./src/client/auth/auth0/Auth0ErrorPage.tsx








const ErrorPage = (0,styled/* default */.Z)(Grid/* default */.Z)(() => ({
  "&": {
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center"
  }
}));
const ErrorBox = (0,styled/* default */.Z)(Box/* default */.Z)(() => ({
  boxShadow: "0 12px 40px rgba(0,0,0,0.12)"
}));
const ErrorOutlineIcon = (0,styled/* default */.Z)(ErrorOutline/* default */.Z)(() => ({
  fontSize: "4.5rem"
}));
const Auth0ErrorPage = ({ title, body }) => {
  const navigate = (0,dist/* useNavigate */.s0)();
  const { logout } = (0,auth0_react_esm/* useAuth0 */.D3)();
  const isDevelopment = ["localhost", "127.0.0.1"].includes(
    window.location.hostname
  );
  function handleBackToLogin() {
    logout();
    navigate((0,links/* linkToAuth0Login */.G2)());
  }
  const defaultTitle = isDevelopment ? "Authentication error" : /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.errorPage.defaultTitle",
    defaultMessage: "Unauthorised"
  });
  const defaultMessage = isDevelopment ? "Please check both auth services are running. If everything is running correctly, check your user is present in Mongo and not set as inactive" : /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.errorPage.body",
    defaultMessage: "Please contact your Elephant system administrator for assistance."
  });
  const titleToRender = title || defaultTitle;
  const bodyToRender = body || defaultMessage;
  return /* @__PURE__ */ react.createElement(Grid/* default */.Z, {
    container: true,
    justifyContent: "center",
    "data-testid": "error-page"
  }, /* @__PURE__ */ react.createElement(ErrorPage, {
    item: true,
    md: 8
  }, /* @__PURE__ */ react.createElement(ErrorBox, {
    p: 4,
    m: 2
  }, /* @__PURE__ */ react.createElement(ErrorOutlineIcon, {
    color: "error"
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h3",
    gutterBottom: true
  }, titleToRender), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1",
    gutterBottom: true
  }, bodyToRender), /* @__PURE__ */ react.createElement(dist_module/* Button */.zx, {
    color: "primary",
    variant: "text",
    onClick: handleBackToLogin
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.errorPage.button",
    defaultMessage: "Back to login"
  })))));
};
/* harmony default export */ const auth0_Auth0ErrorPage = (Auth0ErrorPage);

// EXTERNAL MODULE: ./src/client/routes/NavigateHome.tsx
var NavigateHome = __webpack_require__(55558);
// EXTERNAL MODULE: ./src/client/pages/Loading/index.jsx
var Loading = __webpack_require__(79000);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/errors/index.js
var errors = __webpack_require__(4290);
// EXTERNAL MODULE: ./src/client/auth/SessionTokenProvider/SessionTokenProvider.tsx
var SessionTokenProvider = __webpack_require__(1767);
// EXTERNAL MODULE: ./src/client/utils/environment.ts
var environment = __webpack_require__(68490);
// EXTERNAL MODULE: ./src/client/auth/SigningTokenProvider/SigningTokenProvider.tsx + 1 modules
var SigningTokenProvider = __webpack_require__(48462);
;// CONCATENATED MODULE: ./src/client/auth/auth0/Auth0Callback.tsx










function useCompleteLogin() {
  const {
    isLoading,
    isAuthenticated,
    getIdTokenClaims,
    error: auth0Error,
    getAccessTokenSilently
  } = (0,auth0_react_esm/* useAuth0 */.D3)();
  const { setSessionToken, sessionToken } = (0,SessionTokenProvider/* useSessionTokenContext */.ic)();
  const { signingToken } = (0,SigningTokenProvider/* useSigningTokenContext */.M_)();
  (0,react.useEffect)(() => {
    if (isLoading || !isAuthenticated)
      return;
    if ((0,environment/* isDevEnvironment */.X)()) {
      console.warn(
        "Using beta access token flow, this should not be seen in production yet."
      );
      getAccessTokenSilently().then((r) => setSessionToken(r));
    } else {
      getIdTokenClaims().then((r) => (r == null ? void 0 : r.__raw) && setSessionToken(r.__raw));
    }
  }, [
    isLoading,
    isAuthenticated,
    getIdTokenClaims,
    getAccessTokenSilently,
    setSessionToken,
    sessionToken,
    signingToken
  ]);
  return {
    error: auth0Error,
    success: !!sessionToken
  };
}
const Auth0Callback = () => {
  var _a;
  const { error, success } = useCompleteLogin();
  if (success) {
    return /* @__PURE__ */ react.createElement(NavigateHome/* default */.Z, null);
  }
  if (error instanceof auth0_react_esm/* OAuthError */.BK) {
    const errorMessage = (_a = error.error_description) != null ? _a : error.message;
    if (errorMessage === "user is blocked") {
      return /* @__PURE__ */ react.createElement(auth0_Auth0ErrorPage, {
        title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "auth.errorPage.blocked",
          defaultMessage: "Your account is blocked"
        })
      });
    }
    if (errorMessage.includes("Timeout when executing") || errorMessage.includes("Invalid state")) {
      return /* @__PURE__ */ react.createElement(auth0_Auth0ErrorPage, {
        title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "auth.errorPage.networkIssue.title",
          defaultMessage: "Network Connection Issues"
        }),
        body: /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "auth.errorPage.networkIssue.body",
          defaultMessage: "Please check your connection and try logging in again by clicking the button below."
        })
      });
    }
    return /* @__PURE__ */ react.createElement(auth0_Auth0ErrorPage, null);
  }
  if (error) {
    if ((0,errors/* isApolloError */.MS)(error) && (error == null ? void 0 : error.networkError)) {
      return /* @__PURE__ */ react.createElement(auth0_Auth0ErrorPage, {
        title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "auth.errorPage.apolloNetworkError.title",
          defaultMessage: "ElephantOS is currently experiencing issues, we apologise for the disruption"
        }),
        body: /* @__PURE__ */ react.createElement(message/* default */.Z, {
          id: "auth.errorPage.apolloNetworkError.body",
          defaultMessage: "Please try again later or contact your Elephant system administrator if the issue persists."
        })
      });
    }
    return /* @__PURE__ */ react.createElement(auth0_Auth0ErrorPage, {
      title: /* @__PURE__ */ react.createElement(message/* default */.Z, {
        id: "auth.errorPage.missing",
        defaultMessage: "Your account is inactive or missing permissions"
      })
    });
  }
  return /* @__PURE__ */ react.createElement(Loading/* default */.Z, null);
};


/***/ }),

/***/ 58053:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ Auth0Consent)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(12850);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(5427);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(61800);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+config-provider@2.1.0_cn5jcockkrembw54osxy7yvfpi/node_modules/@elephant-healthcare/config-provider/dist/module.js
var dist_module = __webpack_require__(23198);
// EXTERNAL MODULE: ./src/client/components/ErrorPage/index.tsx
var ErrorPage = __webpack_require__(64493);
// EXTERNAL MODULE: ./src/client/utils/constants.ts
var constants = __webpack_require__(20589);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.9/node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(85961);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(44);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-style@0.2.18_eoxrwrdfnn7iwmzbegnki62dbq/node_modules/@elephant-healthcare/mui-style/dist/module.js
var mui_style_dist_module = __webpack_require__(10353);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/RadioButtonChecked.js
var RadioButtonChecked = __webpack_require__(27766);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+icons@4.11.3_ryzmuchqoqxe7fdkm6pqdvmh5y/node_modules/@material-ui/icons/RadioButtonUnchecked.js
var RadioButtonUnchecked = __webpack_require__(65783);
// EXTERNAL MODULE: ./src/client/components/HTMLControls/Fields/Label/Label.jsx + 3 modules
var Label = __webpack_require__(19895);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-hook-form@7.31.1_react@18.1.0/node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(21235);
// EXTERNAL MODULE: ./src/client/components/HTMLControls/Fields/Radio/styles.tsx
var styles = __webpack_require__(21498);
// EXTERNAL MODULE: ./src/client/forms/hookForm/fields/RHFYesNoRadioInput.tsx
var RHFYesNoRadioInput = __webpack_require__(41054);
;// CONCATENATED MODULE: ./src/client/auth/auth0/consent/common.tsx











const useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  radio: {
    ...(0,styles/* default */.Z)(theme).radio,
    flexShrink: 0,
    marginLeft: theme.spacing(1)
  },
  yesButtonRow: {
    display: "flex",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4)
  }
}));
function YesButton(props) {
  const { setValue, watch } = (0,index_esm/* useFormContext */.Gc)();
  const value = watch(props.name);
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const classes = useStyles({});
  return /* @__PURE__ */ react.createElement("div", {
    className: classes.yesButtonRow
  }, /* @__PURE__ */ react.createElement(Label/* default */.Z, {
    className: "inline-label",
    name: props.name,
    label: props.label,
    required: props.required
  }), /* @__PURE__ */ react.createElement(Button/* default */.Z, {
    className: classes.radio,
    onClick: () => setValue(props.name, !value),
    color: "primary",
    variant: "outlined",
    startIcon: value === true ? /* @__PURE__ */ react.createElement(RadioButtonChecked/* default */.Z, null) : /* @__PURE__ */ react.createElement(RadioButtonUnchecked/* default */.Z, null),
    value: value === true ? "checked" : "",
    "aria-checked": value === true ? "true" : "false",
    role: "radio"
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1"
  }, formatMessage({
    id: "auth.consent.yesButton",
    defaultMessage: "Yes"
  }))));
}
function SoftwareTermsOfUseLink() {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement("a", {
    href: "https://privacy.elephant.healthcare/software-terms-of-use"
  }, formatMessage({
    id: "auth.consent.softwareTermsOfUserLinkText",
    defaultMessage: "Software Terms of Use"
  }));
}
function PrivacyPolicyLink() {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement("a", {
    href: "https://privacy.elephant.healthcare/privacy-policy"
  }, formatMessage({
    id: "auth.consent.privacyPolicyLinkText",
    defaultMessage: "Privacy Policy"
  }));
}
function MarketingInput() {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  return /* @__PURE__ */ react.createElement(react.Fragment, null, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1",
    paragraph: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.marketing.request",
    defaultMessage: "Elephant would like to contact you with relevant product and feature updates that it thinks will be helpful for you."
  })), /* @__PURE__ */ react.createElement(RHFYesNoRadioInput/* default */.Z, {
    name: "marketingConsent",
    label: formatMessage({
      id: "auth.consent.marketing.checkBoxLabel",
      defaultMessage: "Do you give your permission for this?"
    }),
    required: true,
    inline: true,
    noFirst: true
  }));
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@hookform+resolvers@2.9.11_react-hook-form@7.31.1/node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(1793);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-button@0.3.1_blc3y2edg5y5i6susihvdzzxta/node_modules/@elephant-healthcare/mui-button/dist/module.js
var mui_button_dist_module = __webpack_require__(2550);
;// CONCATENATED MODULE: ./src/client/auth/auth0/consent/DefaultConsentForm.tsx









const DefaultConsentForm_useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  button: {
    marginTop: theme.spacing(2),
    float: "right"
  }
}));
function DefaultConsentForm({ handleSubmit }) {
  const classes = DefaultConsentForm_useStyles();
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    resolver: (0,yup/* yupResolver */.X)(
      (0,es.object)({
        marketingConsent: (0,es.bool)().required()
      })
    )
  });
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    "data-testid": "default-consent-form",
    name: "default-consent-form",
    onSubmit: formMethods.handleSubmit(handleSubmit)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1",
    paragraph: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.default.terms",
    defaultMessage: "Elephant must process your personal information in order to set up your professional user account. Your personal information will be processed in accordance with Elephant\u2019s {PrivacyPolicyLink}. By using Elephant, you agree to our {SoftwareTermsOfUseLink}.",
    values: {
      PrivacyPolicyLink: /* @__PURE__ */ react.createElement(PrivacyPolicyLink, null),
      SoftwareTermsOfUseLink: /* @__PURE__ */ react.createElement(SoftwareTermsOfUseLink, null)
    }
  })), /* @__PURE__ */ react.createElement(MarketingInput, null), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    type: "submit",
    className: classes.button,
    color: "primary"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.default.submitButton",
    defaultMessage: "Accept & Continue"
  }))));
}

;// CONCATENATED MODULE: ./src/client/auth/auth0/consent/KenyaConsentForm.tsx









const KenyaConsentForm_useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  privacyButton: {
    display: "flex",
    justifyContent: "flex-end",
    marginBottom: theme.spacing(1)
  },
  button: {
    marginTop: theme.spacing(2),
    float: "right"
  }
}));
function KenyaConsentForm({ handleSubmit }) {
  const classes = KenyaConsentForm_useStyles();
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    resolver: (0,yup/* yupResolver */.X)(
      (0,es.object)({
        marketingConsent: (0,es.bool)().required(),
        kenyaDataConsent: (0,es.bool)().oneOf([true]).required()
      })
    )
  });
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    "data-testid": "kenya-consent-form",
    name: "kenya-consent-form",
    onSubmit: formMethods.handleSubmit(handleSubmit)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1",
    paragraph: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.kenya.privacyTerms",
    defaultMessage: "Elephant must process your personal information in order to set up your professional user account. To keep your information safe it will be encrypted and stored on servers in Kenya and/or the European Union and processed in accordance with Elephant\u2019s {PrivacyPolicyLink}.",
    values: {
      PrivacyPolicyLink: /* @__PURE__ */ react.createElement(PrivacyPolicyLink, null)
    }
  })), /* @__PURE__ */ react.createElement(YesButton, {
    label: formatMessage({
      id: "auth.consent.kenya.privacyConfirmation",
      defaultMessage: "Do you confirm that you are happy for your information to be processed in this way?"
    }),
    name: "kenyaDataConsent",
    required: true
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1",
    paragraph: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.kenya.consentTerms",
    defaultMessage: "By using Elephant, you agree to our {SoftwareTermsOfUseLink}.",
    values: {
      SoftwareTermsOfUseLink: /* @__PURE__ */ react.createElement(SoftwareTermsOfUseLink, null)
    }
  })), /* @__PURE__ */ react.createElement(MarketingInput, null), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    className: classes.button,
    color: "primary",
    type: "submit"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.kenya.submitButton",
    defaultMessage: "Accept & Continue"
  }))));
}

;// CONCATENATED MODULE: ./src/client/auth/auth0/consent/PakistanConsentForm.tsx









const PakistanConsentForm_useStyles = (0,mui_style_dist_module/* makeStyles */.Z)((theme) => ({
  button: {
    marginTop: theme.spacing(2),
    float: "right"
  }
}));
function PakistanConsentForm({ handleSubmit }) {
  const classes = PakistanConsentForm_useStyles();
  const formMethods = (0,index_esm/* useForm */.cI)({
    mode: "all",
    resolver: (0,yup/* yupResolver */.X)(
      (0,es.object)({
        marketingConsent: (0,es.bool)().required()
      })
    )
  });
  return /* @__PURE__ */ react.createElement(index_esm/* FormProvider */.RV, {
    ...formMethods
  }, /* @__PURE__ */ react.createElement("form", {
    "data-testid": "pakistan-consent-form",
    name: "pakistan-consent-form",
    onSubmit: formMethods.handleSubmit(handleSubmit)
  }, /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1",
    paragraph: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.pakistan.privacyTerms",
    defaultMessage: "Elephant must process your personal information in order to set up your professional user account. Your information will be encrypted and stored securely on servers in and outside Pakistan and processed in accordance with Elephant\u2019s Privacy Policy {PrivacyPolicyLink}",
    values: {
      PrivacyPolicyLink: /* @__PURE__ */ react.createElement(PrivacyPolicyLink, null)
    }
  })), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "body1",
    paragraph: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.pakistan.softwareTerms",
    defaultMessage: "By using Elephant, you agree to our Software Terms of Use  {SoftwareTermsOfUseLink}",
    values: {
      SoftwareTermsOfUseLink: /* @__PURE__ */ react.createElement(SoftwareTermsOfUseLink, null)
    }
  })), /* @__PURE__ */ react.createElement(MarketingInput, null), /* @__PURE__ */ react.createElement(mui_button_dist_module/* Button */.zx, {
    className: classes.button,
    color: "primary",
    type: "submit"
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.pakistan.submitButton",
    defaultMessage: "Accept & Continue"
  }))));
}

// EXTERNAL MODULE: ./src/client/utils/useQuerystring.ts
var useQuerystring = __webpack_require__(19894);
;// CONCATENATED MODULE: ./src/client/auth/auth0/Auth0Consent.jsx











const Auth0Consent_useStyles = (0,makeStyles/* default */.Z)((theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  inner: {
    boxShadow: "0 12px 40px rgb(0 0 0 / 12%)",
    width: "90%",
    maxWidth: 600,
    padding: theme.spacing(5),
    borderRadius: 5
  },
  logoImage: {
    maxHeight: 52,
    marginBottom: theme.spacing(3)
  },
  headerRow: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: theme.spacing(3)
  }
}));
function Auth0Consent() {
  const classes = Auth0Consent_useStyles();
  const { territory } = (0,dist_module/* useConfig */.ZR)();
  const { state: auth0State, auth0_domain: auth0Domain } = (0,useQuerystring/* default */.Z)();
  const handleSubmit = (0,react.useCallback)(
    (values) => {
      const common = {
        state: auth0State,
        defaultConsent: "true",
        marketingConsent: String(values.marketingConsent),
        consentVersion: "1"
      };
      const nextParams = new URLSearchParams(
        values.kenyaDataConsent ? {
          ...common,
          kenyaDataConsent: values.kenyaDataConsent
        } : common
      );
      nextParams.toString();
      const redirectTo = `https://${auth0Domain}/continue?${nextParams.toString()}`;
      window.location.href = redirectTo;
    },
    [auth0State, auth0Domain]
  );
  if (!auth0State || !auth0Domain) {
    return /* @__PURE__ */ react.createElement("div", {
      className: classes.root
    }, /* @__PURE__ */ react.createElement(ErrorPage/* default */.Z, {
      error: new Error("Missing state or domain query param")
    }));
  }
  let body = /* @__PURE__ */ react.createElement(DefaultConsentForm, {
    handleSubmit
  });
  if (territory === constants/* TERRITORY.KENYA */.jQ.KENYA) {
    body = /* @__PURE__ */ react.createElement(KenyaConsentForm, {
      handleSubmit
    });
  }
  if (territory === constants/* TERRITORY.PAKISTAN */.jQ.PAKISTAN) {
    body = /* @__PURE__ */ react.createElement(PakistanConsentForm, {
      handleSubmit
    });
  }
  return /* @__PURE__ */ react.createElement("div", {
    className: classes.root
  }, /* @__PURE__ */ react.createElement("div", {
    className: classes.inner
  }, /* @__PURE__ */ react.createElement("div", {
    className: classes.headerRow
  }, /* @__PURE__ */ react.createElement("img", {
    className: classes.logoImage,
    src: "https://static-web-assets.elephantprimarycare.com/branding/elephant-logo-colour-501px_104px.png",
    alt: "Elephant Logo"
  }), /* @__PURE__ */ react.createElement(Typography/* default */.Z, {
    variant: "h3",
    component: "h1",
    gutterBottom: true
  }, /* @__PURE__ */ react.createElement(message/* default */.Z, {
    id: "auth.consent.title",
    defaultMessage: "Consent"
  }))), body));
}


/***/ }),

/***/ 42759:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14432);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76653);
/* harmony import */ var _material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5427);
/* harmony import */ var elephant_web_client_components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80103);
/* harmony import */ var elephant_web_client_components_ErrorPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64493);
/* harmony import */ var _links__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81041);







const useStyles = (0,_material_ui_core_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
  root: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }
});
const Auth0Login = () => {
  const navigate = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_5__/* .useNavigate */ .s0)();
  const { isLoading, loginWithRedirect, user, isAuthenticated, error } = (0,_auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__/* .useAuth0 */ .D3)();
  const classes = useStyles();
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    (async function login() {
      if (!isLoading && !user) {
        await loginWithRedirect({
          prompt: "login"
        });
      }
    })();
  }, [isLoading, loginWithRedirect, user]);
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (isAuthenticated) {
      navigate((0,_links__WEBPACK_IMPORTED_MODULE_6__/* .linkToAuth0Callback */ .MS)());
    }
  }, [isAuthenticated, navigate]);
  if (error) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: classes.root
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(elephant_web_client_components_ErrorPage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      error
    }));
  }
  if (isLoading || !isAuthenticated) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: classes.root
    }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(elephant_web_client_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, null));
  }
  return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Auth0Login);


/***/ }),

/***/ 3234:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var react_router_dom__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76653);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14432);
/* harmony import */ var _elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23198);
/* harmony import */ var elephant_web_client_utils_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68490);





const ELEPHANT_API_AUTH0_AUDIENCE = "https://elephantprimarycare.com";
const Auth0ProviderWithHistory = ({ children }) => {
  const navigate = (0,react_router_dom__WEBPACK_IMPORTED_MODULE_3__/* .useNavigate */ .s0)();
  const {
    auth0: { clientId, domain, internalProxyDomain }
  } = (0,_elephant_healthcare_config_provider__WEBPACK_IMPORTED_MODULE_2__/* .useConfig */ .ZR)();
  const onRedirectCallback = (appState) => {
    navigate((appState == null ? void 0 : appState.returnTo) || window.location.pathname);
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__/* .Auth0Provider */ .tw, {
    domain: internalProxyDomain || domain,
    clientId,
    redirectUri: `${window.location.origin}/auth0/callback`,
    onRedirectCallback,
    cacheLocation: window.Cypress ? "localstorage" : "memory",
    audience: (0,elephant_web_client_utils_environment__WEBPACK_IMPORTED_MODULE_4__/* .isDevEnvironment */ .X)() ? ELEPHANT_API_AUTH0_AUDIENCE : void 0
  }, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Auth0ProviderWithHistory);


/***/ }),

/***/ 81041:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G2": () => (/* binding */ linkToAuth0Login),
/* harmony export */   "MS": () => (/* binding */ linkToAuth0Callback)
/* harmony export */ });
/* unused harmony export linkToAuth0Consent */
function linkToAuth0Login() {
  return "/login";
}
function linkToAuth0Callback() {
  return "/auth0/callback";
}
function linkToAuth0Consent() {
  return "/auth0/consent";
}


/***/ }),

/***/ 89962:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "K$": () => (/* reexport */ ROLES),
  "uU": () => (/* reexport */ dist_module/* Role */.uU)
});

// UNUSED EXPORTS: ACTIONS, ADMIN, CASHOFFICER, CLINIC, DISPENSER, DOCTOR, ELEPHANT, NURSE, PHARMACIST, RESOURCES, ROOT, TECHNICIAN

// EXTERNAL MODULE: ./src/client/admin/routing/links.ts
var links = __webpack_require__(56123);
// EXTERNAL MODULE: ./src/client/clinician/links.tsx
var clinician_links = __webpack_require__(65460);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+role-definitions@3.0.0/node_modules/@elephant-healthcare/role-definitions/dist/module.js
var dist_module = __webpack_require__(4377);
;// CONCATENATED MODULE: ./src/client/auth/constants.ts




const {
  ADMIN,
  CASHOFFICER,
  CLINIC,
  DOCTOR,
  ELEPHANT,
  NURSE,
  PHARMACIST,
  ROOT,
  TECHNICIAN,
  DISPENSER
} = dist_module/* Role */.uU;
const ADMIN_HOME = (0,links/* linkToAdminControlPanel */.IR)();
const CLINICIAN_HOME = (0,clinician_links/* linkToClinicianDashboard */.fV)();
const ROLES = {
  [dist_module/* Role.ADMIN */.uU.ADMIN]: {
    path: ADMIN_HOME
  },
  [dist_module/* Role.CASHOFFICER */.uU.CASHOFFICER]: {
    path: CLINICIAN_HOME
  },
  [dist_module/* Role.CLINIC */.uU.CLINIC]: {
    path: CLINICIAN_HOME
  },
  [dist_module/* Role.DOCTOR */.uU.DOCTOR]: {
    path: CLINICIAN_HOME
  },
  [dist_module/* Role.ELEPHANT */.uU.ELEPHANT]: {
    path: ADMIN_HOME
  },
  [dist_module/* Role.NURSE */.uU.NURSE]: {
    path: CLINICIAN_HOME
  },
  [dist_module/* Role.PHARMACIST */.uU.PHARMACIST]: {
    path: CLINICIAN_HOME
  },
  [dist_module/* Role.TECHNICIAN */.uU.TECHNICIAN]: {
    path: CLINICIAN_HOME
  },
  [dist_module/* Role.DISPENSER */.uU.DISPENSER]: {
    path: CLINICIAN_HOME
  }
};
const ACTIONS = {
  READ: "READ"
};
const RESOURCES = {
  SUPER_USER_ADMIN_PANEL: "super-user-admin-panel",
  FACILITY_REPORTS: "/clinic-admin/facility-reports"
};

;// CONCATENATED MODULE: ./src/client/auth/index.ts



/***/ }),

/***/ 13614:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "assets/elephant-logo-black-240px_51px.png";

/***/ })

}]);